module.exports = __webpack_public_path__ + "img/banner.51bbb647.png";